import { t } from '@lingui/core/macro';
import { CommonMetadataAllowedValuesFilter } from './MetadataAllowedValuesFilter';
export const marketingTrademarkUseFilterLabel = () => t({ message: 'Marketing trademark use', comment: 'Insights filter: Marketing trademark use' });
export function MarketingTrademarkUseFilter() {
    return (<CommonMetadataAllowedValuesFilter name="MarketingTrademarkUse" field="metadataDocumentMarketingTrademarkUse" label={marketingTrademarkUseFilterLabel()}/>);
}
